export default __webpack_public_path__ + "static/media/platform_image.d961b5cf.png";